// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, react:true*/
import {lazy, ComponentType, LazyExoticComponent} from 'react';

type t_lazy_importer = <T>(
    importer: ()=>Promise<T>,
    ...component_names: (keyof T)[]
)=>Record<keyof T, LazyExoticComponent<ComponentType<any>>>;

export const lazy_importer: t_lazy_importer = (importer, ...component_names)=>{
    let chunk = null;
    return component_names.reduce((acc: any, name)=>{
        acc[name] = lazy(()=>{
            if (!chunk)
                chunk = importer();
            return chunk.then((module: any)=>{
                let Cmp = module[name];
                if (!Cmp && module.default && module.default[name])
                    Cmp = module.default[name];
                if (!Cmp && name == 'default')
                    Cmp = module.default;
                return {default: Cmp};
            });
        });
        return acc;
    }, {});
};
